import { useTranslation } from "react-i18next";

export type ProgressStep = {
  label: string;
  isComplete: boolean;
  onClick?: () => void;
};

type ProgressStepInput = {
  uploadedMaterials?: number;
  createdQuestions?: number;
  fileUploadRef?: React.RefObject<HTMLDivElement | null>;
  navigate: (path: string) => void;
};

export const createProgressSteps = ({
  uploadedMaterials,
  createdQuestions,
  fileUploadRef,
  navigate,
}: ProgressStepInput): ProgressStep[] => {
  const { t } = useTranslation(["coursePage"]);
  const uploaded = uploadedMaterials ?? -1; // -1 means "not started"
  const created = createdQuestions ?? -1;

  const firstComplete = uploaded > 0;
  const secondComplete = firstComplete && created >= 10;
  const thirdComplete = secondComplete && created >= 100;

  return [
    {
      label: t("courseSetupTracker.uploadLabel"),
      isComplete: firstComplete,
      onClick: () => {
        fileUploadRef?.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      },
    },
    {
      label: t("courseSetupTracker.question10Label"),
      isComplete: secondComplete,
      onClick: () => navigate("manage/quiz"),
    },
    {
      label: t("courseSetupTracker.question100Label", {
        count: Math.max(0, 100 - Math.max(0, created)),
      }),
      isComplete: thirdComplete,
      onClick: () => navigate("manage/quiz"),
    },
  ];
};
